// extracted by mini-css-extract-plugin
module.exports = {"nativeAdContainer":"nativeAdContainer___1gCFH"};